export let pallettes = [
	[
		0xcd565b,
		0xeff2f5,
		0x3e3e51,
		0x8c96a6
	],
	[
		0xe9dbcd,
		0xf2b15f,
		0x394c46,
		0xd8b893
	],
	[
		0xafc6bb,
		0x21211d,
		0xc18c58,
		0x657e7e
	],
	[
		0xdd6b74,
		0xf6e9de,
		0x593443,
		0xe7a49a
	]
]